import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

import { CustomPreloader } from './preloaders/custom.preloader';

import { PUBLIC_ROUTES } from './routes/public.routes';

import { PublicLayoutComponent } from '../layout/components/public-layout/public-layout.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HasRequiredRoutesGuard } from './guards/has-required-routes.guard';
import { DashboardService } from '../dashboard/services/dashboard.service';
import { SharedModule } from '../shared/shared.module';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/course',
    pathMatch: 'full',
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: PUBLIC_ROUTES,
  },
  {
    path: '',
    loadChildren: () => import('../layout/authenticated-layout.module').then(m => m.AuthenticatedLayoutModule),
    canActivate: [HasRequiredRoutesGuard],
  },
  {
    path: '',
    loadChildren: () => import('../layout/course-layout.module').then(m => m.CourseLayoutModule),
    canActivate: [],
  },

  // Catches any routes that are not registered above
  {
    path: '**',
    redirectTo: '/404',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: CustomPreloader,
      paramsInheritanceStrategy: 'always',
      scrollPositionRestoration: 'enabled',
    }),
    MatProgressBarModule,
    BrowserModule,
    TranslateModule,
    SharedModule,
  ],
  providers: [
    DashboardService,
    CustomPreloader,
  ],
  exports: [
    RouterModule,
  ],
  declarations: [
    NotFoundComponent,
  ],
})
export class RoutingModule {
}
